// Shared error texts – i18n manifest (veřejný kontrakt pro composition)

import type { SliceI18nManifest } from '@/shared/lib/vsa';
import cs from './locales/cs.json';
import en from './locales/en.json';

const NS = 'errors';

export const errorsI18nManifest: SliceI18nManifest = {
  owner: 'shared/errors',
  namespaces: [NS],
  resources: {
    cs: {
      [NS]: cs,
    },
    en: {
      [NS]: en,
    },
  },
};
